import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const notificationCreate = (params = '') => Http.post('/v1/create-notifications', params)

export const deleteScheduledNotification = params => Http.delete(`/v1/scheduled-notifications/${params.id}`)
export const getScheduledNotifications = (params = '') => Http.get(`/v1/scheduled-notifications${serialize(params)}`)
